import { render, staticRenderFns } from "./AgentStatistics.vue?vue&type=template&id=997f9a7c&scoped=true&"
import script from "./AgentStatistics.vue?vue&type=script&lang=js&"
export * from "./AgentStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AgentStatistics.vue?vue&type=style&index=0&id=997f9a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997f9a7c",
  null
  
)

export default component.exports